import script from "./MyPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPhone.vue?vue&type=script&setup=true&lang=ts"

import "./MyPhone.vue?vue&type=style&index=0&id=34f75980&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f75980"]])

export default __exports__